import React from 'react'
import PropTypes from 'prop-types'
import './CheckboxField.css'
import ValidationUI from "../ValidationUI";

const CheckboxField = ({ value, onChange, label, style, disabled, touched, error, t = x => x }) => (
    <div className="CheckboxField" style={{...(style || {})}}>
        <label style={{display: "flex"}}>
            <input
                type="checkbox"
                className="CheckboxField-input"
                checked={value}
                onChange={() => undefined}
                disabled={disabled}
            />
            <span className="cr" onClick={event => {
                if(onChange) {
                    event.stopPropagation()
                    !disabled && onChange(!value)
                }
            }}>
                        <i className="cr-icon glyphicon glyphicon-ok" onClick={event => {
                            if(!onChange) {
                                event.stopPropagation()
                            }
                        }} />
                    </span>
            {label && <div className="CheckboxField-label" onClick={event => event.stopPropagation()}> {t(label)} </div>}
        </label>
        { touched && (error && <ValidationUI error={error} t={t}/>) }
    </div>

)

CheckboxField.propTypes = {
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired
}

export default CheckboxField
